import Badge, { BadgeProps } from '@mui/material/Badge';
import React from 'react';
import { styled } from '@mui/material';

const StyledBadge = styled(Badge)<BadgeProps>((props) => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#d00070',
    color: 'white',
    top: props.children ? -5 : 0,
    right: props.children ? -5 : 0,
  },
}));

type UnreadBadgeProps = {
  children?: React.ReactNode;
  count?: number;
};

export const UnreadBadge = (props: UnreadBadgeProps) => {
  return (
    <StyledBadge
      badgeContent={props.count || 0}
      max={10}
      overlap='circular'
      sx={{ justifyContent: 'center', maxWidth: '100%' }}
    >
      {props.children}
    </StyledBadge>
  );
};
